import { h, Component } from 'preact';
import BaseIcon from './BaseIcon';

export default (props)=>(
    <BaseIcon viewBox="0 0 448 512" class={props.class}>
        <path 
            fill="currentColor" 
            d="M416 352c-8.188 0-16.38-3.125-22.62-9.375L224 173.3l-169.4 169.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25C432.4 348.9 424.2 352 416 352z"
        >
        </path>
    </BaseIcon>
)


// WEBPACK FOOTER //
// ./components/elements/FontAwesome/FAChevronUp.js